import { render, staticRenderFns } from "./MultipleListCreate.vue?vue&type=template&id=5fdee16a"
import script from "./MultipleListCreate.vue?vue&type=script&lang=js"
export * from "./MultipleListCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports